import React, { useEffect, useRef } from "react";
import { 
  gl_start, mxm, scale, move, turnZ, setUniform, 
  drawObj, Matrix 
} from "./webgl9.js";
import { implicitSurfaceTriangleMesh, Blobs } from "./implicit.js";

export default function WebCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

function Scene() {
this.vertexShader = `#version 300 es
uniform mat4 uMF, uMI, uMat[20];

in  vec3 aPos, aNor, aWts0, aWts1;
out vec3 vPos, vNor;

void main() {
    vec4 p = uMF * vec4(aPos, 1.);
    vec4 pos = vec4(0.);
    for (int i = 0 ; i < 20 ; i++) {
      if (i == int(aWts0.x)) pos += mod(aWts0.x, 1.) * (uMat[i] * p);
      if (i == int(aWts0.y)) pos += mod(aWts0.y, 1.) * (uMat[i] * p);
      if (i == int(aWts0.z)) pos += mod(aWts0.z, 1.) * (uMat[i] * p);
      if (i == int(aWts1.x)) pos += mod(aWts1.x, 1.) * (uMat[i] * p);
      if (i == int(aWts1.y)) pos += mod(aWts1.y, 1.) * (uMat[i] * p);
      if (i == int(aWts1.z)) pos += mod(aWts1.z, 1.) * (uMat[i] * p);
    }
    vec4 nor = vec4(aNor, 0.) * uMI;
    gl_Position = pos * vec4(1.0, 1.0, -0.1, 1.0);
    vPos = pos.xyz;
    vNor = nor.xyz;
}`;

this.fragmentShader = `#version 300 es
precision highp float;
in  vec3 vPos, vNor;
out vec4 fragColor;
uniform vec3 uColor;

void main() {
   vec3 nor = normalize(vNor);
   float c = .1 + max(0., dot(vec3( .5),nor))
                + max(0., dot(vec3(-.5),nor));
   fragColor = vec4(c * uColor, 1.);
}`;

let blobs = new Blobs();
let m1 = mxm(move(-.13,-.05,0), scale(.21,.07,.07));
let m2 = mxm(move(-.01, .00,0), scale(.08,.05,.05));
let m3 = mxm(move( .14,-.05,0), scale(.20,.06,.06));

blobs.addBlob(blobs.SPHERE, m1, .5);
blobs.addBlob(blobs.SPHERE, m2, .5);
blobs.addBlob(blobs.SPHERE, m3, .5);

let mesh = { data: implicitSurfaceTriangleMesh(blobs, 150) };
let M = new Matrix();

this.update = () => {
  let time = Date.now() / 1000;
  let A, B, C;
  let bend = Math.cos(time) * .5 - .5;

  M.push();
    M.move(-.2-.2*bend, .55-.2*bend, 0);
    M.turnZ(-Math.PI/2 - bend);
    M.move(.3, 0, 0);
    A = M.get();
    M.move(.05, 0, 0);
    M.turnZ(bend);
    M.move(.05-.1*bend, 0, 0);
    B = M.get();
    M.move(.05, 0, 0);
    M.turnZ(bend);
    M.move(.05, 0, 0);
    C = M.get();
  M.pop();

  setUniform('Matrix4fv', 'uMat', false, [A,B,C].flat());
  
  // Set vertex attributes for implicit surface
  let gl = canvas.gl;
  let vertexSize = 0;
  let map = ['aPos',3,'aNor',3,'aWts0',3,'aWts1',3];
  for (let n = 0; n < map.length; n += 2)
    vertexSize += map[n+1];
  let index = 0;
  for (let n = 0; n < map.length; n += 2) {
    let attr = gl.getAttribLocation(gl.program, map[n]);
    gl.enableVertexAttribArray(attr);
    gl.vertexAttribPointer(attr, map[n+1], gl.FLOAT, false, vertexSize * 4, index * 4);
    index += map[n+1];
  }
  
  // Pass the vertex size (12 = 3+3+3+3 for pos+nor+wts0+wts1)
  drawObj(mesh, scale(2), [1,.7,.5], 12);
}


    }

    gl_start(canvas, new Scene());
    
    return () => canvas.stopRender && canvas.stopRender();
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
      <canvas ref={canvasRef} width={400} height={400}
        style={{ width: "400px", height: "400px", display: "block", margin: "0 auto", background: "black" }} />
    </div>
  );
}